import { env } from "./env";

/** Versioned API prefix. Mirrors `settings.api_prefix` in services/api. */
export const API_PREFIX = "/api/v1";

/** Absolute URL for a versioned API path, e.g. apiUrl("/auth/refresh"). */
export function apiUrl(path: `/${string}`): string {
  return `${env.VITE_API_ORIGIN}${API_PREFIX}${path}`;
}
